module.exports = __webpack_public_path__ + "b71d98c9.png";